import { IconButton as MuiIconButton, IconButtonProps as IconButtonProps } from '@mui/material';

export const IconButton = ({ children, ...otherProps }: IconButtonProps) => {
  return <MuiIconButton {...otherProps}>{children}</MuiIconButton>;
};
